module.exports = __webpack_public_path__ + "assets/videos/banner-video-poster.jpg?v=92c0183f";